/*
 * File: LoginFormHandler.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles redirecting the user to the default page set in prefences after a valid login
 */
import React from "react";
import PropTypes from "prop-types";
import useLogin from "../state/useLogin";

const LoginFormHandler = ({ children, onLoginSuccess }) => {
  // login state
  const { valid, loggingIn, error, onSubmit, wasAutoLoggedOut } = useLogin(
    onLoginSuccess
  );

  // props for child component
  const childProps = {
    valid,
    loggingIn,
    error,
    onSubmit,
    wasAutoLoggedOut
  };

  return React.cloneElement(children, childProps);
};

LoginFormHandler.propTypes = {
  children: PropTypes.node,
  onLoginSuccess: PropTypes.func.isRequired
};

export default LoginFormHandler;
